var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4352 0.129222L1.52352 8.77625C1.29891 8.88469 1.15625 9.11203 1.15625 9.36141V30.6386C1.15625 30.888 1.29898 31.1153 1.52352 31.2238L19.4352 39.8708C19.7921 40.0431 20.2082 40.0431 20.5652 39.8708L38.4768 31.2238C38.7014 31.1153 38.8441 30.888 38.8441 30.6386V9.36141C38.8441 9.11203 38.7013 8.88469 38.4768 8.77625L20.5652 0.129222C20.2082 -0.0430435 19.7921 -0.0430435 19.4352 0.129222Z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2643 9.00571C1.19602 9.10969 1.15625 9.23211 1.15625 9.36141V30.6386C1.15625 30.888 1.29898 31.1153 1.52352 31.2238L19.4352 39.8707C19.6136 39.9569 19.8069 39.9999 20.0002 39.9999V18.0506L1.2643 9.00571Z",
    fill: "#FFC350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7359 9.00571C38.8041 9.10969 38.8439 9.23211 38.8439 9.36141V30.6386C38.8439 30.888 38.7012 31.1153 38.4766 31.2238L20.565 39.8707C20.3866 39.9569 20.1933 40 20 40V18.0506L38.7359 9.00571Z",
    fill: "#FFD164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5162 29.5045C6.42167 29.5045 6.32519 29.4835 6.23449 29.4398L3.4691 28.1047C3.1455 27.9486 3.01035 27.5602 3.16644 27.2373C3.32191 26.9143 3.71152 26.7798 4.03386 26.9346L6.79925 28.2698C7.12285 28.4259 7.258 28.8142 7.10191 29.1372C6.99027 29.3693 6.758 29.5045 6.5162 29.5045Z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06149 27.8477C8.96696 27.8477 8.87047 27.8267 8.77977 27.783L3.47289 25.2213C3.14993 25.0652 3.01414 24.6768 3.17024 24.3538C3.32571 24.0315 3.71594 23.8963 4.03766 24.0512L9.34446 26.6129C9.66743 26.769 9.80321 27.1574 9.64711 27.4803C9.53555 27.7124 9.30329 27.8477 9.06149 27.8477Z",
    fill: "#FFF6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3869 12.0604L13.5852 2.97734L8.62891 5.37968L27.4728 14.4768L32.3869 12.0604Z",
    fill: "#EB423F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4727 14.4768V21.5242C27.4727 21.7638 27.723 21.9209 27.9388 21.8168L32.0195 19.8469C32.2441 19.7384 32.3867 19.5111 32.3867 19.2617V12.0605L27.4727 14.4768Z",
    fill: "#D03A38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderReady);
export default __webpack_public_path__ + "static/media/orderReady.320d801442e5115d7ec5d2690b0471ed.svg";
export { ForwardRef as ReactComponent };